<template>
  <path
    d="M18 4.00018H6C4.9 4.00018 4 4.90018 4 6.00018V18.0002C4 19.1002 4.9 20.0002 6 20.0002H18C19.1 20.0002 20 19.1002 20 18.0002V6.00018C20 4.90018 19.1 4.00018 18 4.00018ZM17 18.0002H7C6.45 18.0002 6 17.5502 6 17.0002V7.00018C6 6.45018 6.45 6.00018 7 6.00018H17C17.55 6.00018 18 6.45018 18 7.00018V17.0002C18 17.5502 17.55 18.0002 17 18.0002Z"
  />
</template>
